import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function TalentPoolLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, logout } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await login(email, password);
      if (r.user?.role !== "talent_pool_member") {
        logout();
        toast.error("This sign-in page is for talent-pool applicants only.");
        return;
      }
      toast.success("Signed in");
      nav("/talent-pool/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Sign in failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center p-6 md:p-12">
      <div className="w-full max-w-md">
        <Link to="/" className="text-xs uppercase tracking-[0.2em] text-ink font-semibold" data-testid="tp-login-home">
          ← Railway Careers UK
        </Link>

        <div className="mt-4 bg-card border border-border rounded-lg p-8">
          <h1 className="font-display font-extrabold text-ink text-2xl">Talent pool sign in</h1>
          <p className="text-sm text-muted-foreground mt-2">
            Sign in to your talent-pool applicant account.
          </p>

          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="tp-login-form">
            <div>
              <Label>Email</Label>
              <Input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1"
                data-testid="tp-login-email"
              />
            </div>
            <div>
              <div className="flex items-center justify-between gap-3">
                <Label>Password</Label>
                <Link
                  to="/talent-pool/forgot-password"
                  className="text-xs text-ink/70 hover:text-ink underline-offset-4 hover:underline"
                  data-testid="tp-login-forgot"
                >
                  Forgot?
                </Link>
              </div>
              <Input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1"
                data-testid="tp-login-password"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-navy text-white hover:bg-lime-600 hover:text-slate-950 font-semibold"
              data-testid="tp-login-submit"
            >
              {loading ? "Signing in…" : "Sign in"}
            </Button>
          </form>

          <div className="mt-4 text-sm text-muted-foreground">
            New here?{" "}
            <Link to="/talent-pool/register" className="text-ink font-semibold underline-offset-4 hover:underline">
              Register interest
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
